import { UISelect } from '~/components/common/forms';
import { Translate, useTranslate } from '~/i18n';

type StatusFilterProps = {
   options?: { label: string; value: string }[];
   onChange?: (a: any) => void;
   statusFilter?: string;
};

const StatusFilter = ({ onChange, statusFilter }: StatusFilterProps) => {
   const { translate } = useTranslate();
   const options = [
      { label: translate({ id: 'productsList:active' }), value: 'Active' },
      { label: translate({ id: 'coupons:inactive' }), value: 'Disabled' },
   ];
   return (
      <UISelect
         onChange={(val: any) => onChange?.(val?.value || null)}
         options={options}
         groupClassName="!mb-0"
         placeholder={<Translate id="bookings:sort by" />}
         value={options.filter((item: any) => item.value === statusFilter)}
         isClearable={true}
         instanceId="type-search"
         //  isMulti={true}
      />
   );
};

export default StatusFilter;
